import {Fragment, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faUser, faKey, faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import '../auth.css'
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL;

function AdminSignIn() {
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [disableBtn, setDisableBtn] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const redirect = searchParams.get("redirect") || "/ai-chatbot/administrator";

    useEffect(() => {
        const savedRemember = localStorage.getItem("adminRememberMe") === "true";
        const savedEmail = localStorage.getItem("adminRememberedEmail");
        const savedPassword = localStorage.getItem("adminRememberedPassword");

        setRememberMe(savedRemember);
        reset({
            UserNameOrEmail: savedEmail ?? "",
            Password: savedPassword ?? ""
        })
    }, []);

    const onSubmit = (data) => {
        setErrorMessage("");
        setDisableBtn(true);
        axios.post(`${apiUrl}/api/auth/admin-signin`, data, {
            withCredentials: true
        })
            .then((res) => {
                if (res.data?.Succeeded) {
                    navigate(redirect, { replace: true });
                    localStorage.setItem("adminRememberMe", rememberMe);
                    if (rememberMe) {
                        localStorage.setItem("adminRememberedEmail", data.UserNameOrEmail);
                        localStorage.setItem("adminRememberedPassword", data.Password);
                    } else {
                        localStorage.removeItem("adminRememberedEmail");
                        localStorage.removeItem("adminRememberedPassword");
                    }
                }
                else
                {
                    if(res.data?.Requires2FA) {
                        navigate("/auth/account/2fa-authen", { replace: true });
                    }
                    else if (res.data?.Locked){
                        navigate("/auth/lock-account", {
                            replace: true
                        });
                    }
                    else
                    {
                        setErrorMessage(res.data?.Message);
                    }
                }
            })
            .catch((err) => {
                
            })
            .finally(() => {
                setDisableBtn(false)
            })
    };

    return (
        <Fragment>
            <div className="text-center mb-7">
                <h3 className="text-body-highlight">Sign In Admin Account</h3>
                <p className="text-body-tertiary fs-8-1 mt-2">Enter your email address and password to access admin dashboard.</p>
            </div>
            {
                errorMessage &&
                (
                    <div className="text-center rounded py-1" style={{ backgroundColor: "#f3dfc3" }}>
                        <span className="text-danger fw-bold fs-9">{errorMessage}</span>
                    </div>
                )
            }
            <form onSubmit={handleSubmit(onSubmit)} id="formAdminSignIn">
                <input type="text" style={{ display: "none" }} autoComplete="username" />
                <input type="password" style={{ display: "none" }} autoComplete="current-password" />
                <div className="mb-3 text-start">
                    <label className="form-label" htmlFor="email">Email or username</label>
                    <div className="form-icon-container">
                        <input className="form-control form-icon-input" id="email" type="text" placeholder="name@example.com"
                               {...register("UserNameOrEmail", { required: "Email or username is required" })}/>
                        <FontAwesomeIcon icon={faUser} className="form-icon fs-9 text-body"/>
                    </div>
                    {errors.UserNameOrEmail && (
                        <p className="fs-9 fw-bold text-danger mt-1">{errors.UserNameOrEmail.message}</p>
                    )}
                </div>
                <div className="mb-3 text-start"><label className="form-label" htmlFor="password">Password</label>
                    <div className="form-icon-container" data-password="data-password">
                        <input className="form-control form-icon-input pe-6" id="password" type={!showPassword ? "password" : "text"} placeholder="Password"
                               data-password-input="data-password-input"
                               {...register("Password", { required: "Password is required" })}
                        />
                        <FontAwesomeIcon icon={faKey} className="form-icon fs-9 text-body"/>
                        <button type="button" className="btn px-3 py-0 h-100 position-absolute top-0 end-0 fs-7 text-body-tertiary"
                                data-password-toggle="data-password-toggle">
                            <FontAwesomeIcon onClick={() => setShowPassword(prev => !prev)} icon={!showPassword ? faEye : faEyeSlash} className="fs-9"/>
                            <span className="uil uil-eye-slash hide"></span>
                        </button>
                    </div>
                    {errors.Password && (
                        <p className="fs-9 fw-bold text-danger mt-1">{errors.Password.message}</p>
                    )}
                </div>
            </form>
            <div className="row flex-between-center mb-7">
                <div className="col-auto">
                    <div className="form-check mb-0">
                        <input className="form-check-input" id="basic-checkbox" type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)}/>
                        <label className="form-check-label mb-0" htmlFor="basic-checkbox">Remember me</label>
                    </div>
                </div>
            </div>
            <button type="submit" form="formAdminSignIn" disabled={disableBtn} className="btn btn-primary w-100 mb-3">
                {
                    disableBtn && (
                        <span role="status" aria-hidden="true" className="spinner-border spinner-border-sm me-3"></span>
                    )
                }
                Sign In</button>
        </Fragment>
    )
}

export default AdminSignIn;